import AboutUsModule from 'components/about-us/AboutUsModule';
import AboutUsSiteContainer from 'components/about-us/AboutUsSiteContainer';
import { DaymadeDesignSystemPreviewComponentInfo } from '../';

const ComponentPreview = () => {
  return (
    <>
      <AboutUsModule background={'tealGradient'}>
        <AboutUsSiteContainer>
          <h3 className="aboutUsTypographyHeaderLarge">
            Modules and containers
          </h3>
          <p>
            Modules control the horizontal coloured bands of content across a
            page. The module provides the vertical padding within the coloured
            band.
          </p>
          <p>
            Each module usually has a container, which centers and pads the
            content to the middle of the screen.
          </p>
        </AboutUsSiteContainer>
      </AboutUsModule>
      <AboutUsModule background={'white'} withNoPadding>
        <div
          style={{
            textAlign: 'center',
            padding: 0,
            border: '5px dotted blue',
          }}
        >
          <p style={{ width: '50%', margin: 'auto' }}>
            However, some components use the full width of the screen. For
            example, this component has a dotted border all of the way around it
            touching the edges of the screen. These components need to provide
            their own padding or centre their content. A component that may need
            to set withNoPadding on its Module to remove the vertical spacing
            between Modules.
          </p>
        </div>
      </AboutUsModule>
      <AboutUsModule background="grey">
        <AboutUsSiteContainer>
          <p>
            Both modules will receive vertical spacing when two different
            coloured modules are placed next to each other.
          </p>
        </AboutUsSiteContainer>
      </AboutUsModule>
      <AboutUsModule background="grey">
        <AboutUsSiteContainer>
          <p>
            However, that space is not present if two consecutive modules are
            the same colour. This is to reduce the amount of blank space that
            would otherwise appear. The following/succeeding module has its top
            spacing removed.
          </p>
        </AboutUsSiteContainer>
      </AboutUsModule>
      <AboutUsModule background="tealSolid">
        <AboutUsSiteContainer>
          <p>This is a tealSolid background</p>
        </AboutUsSiteContainer>
      </AboutUsModule>
    </>
  );
};

ComponentPreview.daymadeDesignSystemInfo = {
  name: 'Modules and Containers',
} as DaymadeDesignSystemPreviewComponentInfo;

export default ComponentPreview;
